<script setup>
import { storeToRefs } from 'pinia';
import { useAddressStore } from '@stores/useAddressStore';
import { trans } from '@elements/translation';
import SellerBrandPhotoList from './SellerBrandPhotoList.vue';

const store = useAddressStore();
const { completePageSpaceUrl } = storeToRefs(store);
</script>

<template>
  <div class="address-photo-view">
    <h3>{{ trans('addresses.details.photos.title') }}</h3>

    <!-- eslint-disable vue/no-v-html -->
    <p
      class="seller-brand-description__subtitle"
      v-html="trans('addresses.details.photos.subtitle', { link: completePageSpaceUrl })"
    />
    <!-- eslint-enable vue/no-v-html -->

    <SellerBrandPhotoList class="address-photo-view__content" />
  </div>
</template>
